import { Component, Input, OnInit } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService } from 'vhobjects-service';
import { NzImageService } from 'ng-zorro-antd/image';

@Component({
  selector: 'atw-image-repeat-admin-config',
  templateUrl: './image-repeat-admin-config.component.html',
  styleUrls: ['./image-repeat-admin-config.component.scss']
})
export class AtwImageRepeatAdminConfig extends AtwUpdateDbComponent implements OnInit {
  isCollapsed: boolean = false;
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() type: any;
  effect_hover = [];
  effect_hover_data: any = {};
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
  // Mảng chứa nội dung các dropdown cài đặt
  style_fields = [
    {
      title: "do_bao_phu",
      index: 0,
      isDrop: false
    },
    {
      title: "bo_tron",
      index: 1,
      isDrop: false
    },
    {
      title: "cau_hinh_chi_tiet_hieu_ung",
      index: 2,
      isDrop: false
    },
    {
      title: "bien_doi",
      index: 3,
      isDrop: false
    },
  ];

  chooseDevice: any = 'desktop'; // biến này để xác định upload ảnh cho thiết bị nào ở trường hợp no-compress-one
  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    private nzMessageService: NzMessageService,
    private matdialog: MatDialog,
    private translate: TranslateService,
    public functionService: FunctionService,
    private nzImageService: NzImageService,
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    // Kiểm tra nếu chưa có config thì thêm để người dùng không cần xóa thêm lại
    if (!this.config.hasOwnProperty('position_onscroll')) {
      this.config.position_onscroll = {
        type: 0,
        top: 0,
      };
    }

    if (!this.config.hasOwnProperty('is_top_page')) this.config.is_top_page = false;
    if (!this.config['image-fullscreen']?.hasOwnProperty('toggle_fullscreen')) {
      this.config['image-fullscreen'] ??= {};
      this.config['image-fullscreen'].toggle_fullscreen = false;
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/image.json'),
    ]).subscribe(([effects, background_colors]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.setCustomize(this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || []);
    }

    if (this.class['image']?.['background-image'] && this.class['image']['background-image'].includes('url(')) {
      this.class['image']['background-image'] = 'none';
    }
  }

  handleOpenFullscreenPreview() {
    const srcTemp = this.staticdata?.value || 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
    const img_preview = [
      {
        src: srcTemp,
        height: '90%',
        position: 'fixed',
      },
    ]
    this.nzImageService.preview(img_preview, { nzZoom: 0.9, nzRotate: 0 });
  }

  /** Xử lí xoay lật
   * @param axis : Lật theo trục 'x' | 'y' | 'z' | '-z'
   */
  handleSetTransform(axis) {
    switch (axis) {
      case 'x': // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'y': // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        } else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case '-z': // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['image__boundary'].transform =
            'rotateX(' +
            this.config['transform'].transform_rotateX +
            'deg) ' +
            'rotateY(' +
            this.config['transform'].transform_rotateY +
            'deg) ' +
            'rotateZ(' +
            this.config['transform'].transform_rotateZ +
            'deg) ' +
            'skewX(' +
            this.config['transform'].transform_skewX +
            'deg) ' +
            'skewY(' +
            this.config['transform'].transform_skewY +
            'deg) ';
        }
        break;
      case 'z': // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['image__boundary'].transform =
          'rotateX(' +
          this.config['transform'].transform_rotateX +
          'deg) ' +
          'rotateY(' +
          this.config['transform'].transform_rotateY +
          'deg) ' +
          'rotateZ(' +
          this.config['transform'].transform_rotateZ +
          'deg) ' +
          'skewX(' +
          this.config['transform'].transform_skewX +
          'deg) ' +
          'skewY(' +
          this.config['transform'].transform_skewY +
          'deg) ';
        break;
      default:
    }
    this.updateObject();
  }
  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['image__boundary'].transform =
      'rotateX(' +
      this.config['transform'].transform_rotateX +
      'deg) ' +
      'rotateY(' +
      this.config['transform'].transform_rotateY +
      'deg) ' +
      'rotateZ(' +
      this.config['transform'].transform_rotateZ +
      'deg) ' +
      'skewX(' +
      this.config['transform'].transform_skewX +
      'deg) ' +
      'skewY(' +
      this.config['transform'].transform_skewY +
      'deg) ';
  }
  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData(isMessage = false) {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool) => {
        
  //       if(bool && isMessage) {
  //        this.createMessage('success', 'luu_anh_thanh_cong', 5000)
  //       }
  //     });
  // }
  createMessage(type: string, key: string, duration: number = 2000) {
    this.translate.get(key).subscribe((translatedMessage: string) => {
      this.nzMessageService.create(type, translatedMessage, { nzDuration: duration });
    });
  }
  
  customize = [];
  // /**
  //  *Hàm update config vào database.
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }
  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //       [this.device + '_config']: this.config,
  //       staticdata: this.staticdata,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }
  // /**
  //  *Hàm update class vào database.
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {
        
  //     });
  // }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }
  
  /** Áp dụng đổ bóng
   *   * -> xử lí dữ liệu bóng -> css:  box-shadow: `x y blur color`
   */
  handleSetShadow() {
    if (this.config.check_shadow == false)
      this.class['image__boundary--img']['box-shadow'] = 'none';
    else {
      this.class['image__boundary--img'].transform = 0.8;
      this.class['image__boundary--img'][
        'box-shadow'
      ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_color}`;
    }
    this.updateObject();
  }
  /** Xử lí đổ bóng
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
   */
  handleSetPositionShadow() {
    this.class['image__boundary--img'][
      'box-shadow'
    ] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    this.updateObject();
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  
  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionImage() {
    if (this.config.image.object_x == 0 && this.config.image.object_y == 0)
      this.class['image__boundary--img']['object-position'] = 'initial';
    else {
      this.class['image__boundary--img'][
        'object-position'
      ] = `${this.config.image.object_x}px ${this.config.image.object_y}px`;
    }
    this.updateObject();
  }

  //Hàm xử lý scale
  scale() {
    this.class['image__boundary--img'][
      'transform'
    ] = `scale(${this.class['image__boundary--img']['transfrom_scale']})`;
    this.updateClass();
  }


  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect = this.objectChoosing[this.device + '_config']['animation-selected'];
    this.class['image__boundary'].transform = '';
    this.class['image']['box-shadow'] = '';
    if (effect.id == '000010') {
      this.class['image__boundary--img']['height'] = '';
    } else if (effect.id == '000007') {
      this.class['image__boundary--img']['filter'] = '';
    } else {
      this.class['image__boundary--img']['height'] = '100%';
      this.class['image__boundary--img']['filter'] =
        'brightness(100%)  contrast(100%)  saturate(100%)   hue-rotate(0deg)   blur(0px)   opacity(100%)   grayscale(0%)';
    }

    this.updateObject();

    this.setCustomize(event);

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.style_fields[2]);
    }
  }

  private setCustomize(value) {
    this.customize = value;

    if (['000014', '000035', '000046', '000060'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--6-img-src');
    }
    else if (['000010', '000042', '000043', '000044'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--1-transition' && item.var !== '--0h1-transition');
      this.customize.unshift({ label: "toc_do_cua_hieu_ung", type: "custom-speed", var: "--1-speed-transition" });
    }
    else if (['000027', '000028'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--1-animation-duration-shared' && item.var !== '--0h1-animation-duration-shared');
      this.customize.unshift({ label: "toc_do_cua_hieu_ung", type: "custom-speed", var: "--1-speed-animation" });
    }

    if (this.staticdata?.[this.device + '_animation']?.['animation-0']?.['--0b-content-used-name']) {
      this.customize = this.customize.filter(item => item.var !== '--0b-content');
    }
  }
}
